document.addEventListener('change', function (e) {
  if (!e.target.classList.contains('variant-change-dropdown')) return;

const select = e.target;
const newVariantId = select.value;
const line = select.dataset.line;

const inputQty = document.querySelector('.quantity__input').value;

const productParent = select.closest('.product-description');

let productOption = productParent.querySelector('.product-option dd');

const selectedText = select.options[select.selectedIndex].text;

productOption.innerText = selectedText;
console.warn('inputQty:', inputQty);

  if (!newVariantId || !line) return;

  const cartItem = select.closest('li');
  cartItem?.classList.add('loading');

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      line: Number(line),
      quantity: 0
    })
  })
  .then(() => {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: newVariantId,
        quantity: Number(inputQty)
      })
    });
  })
  .then(() => {
    return fetch('/?section_id=mini-cart');
  })
  .then(res => res.text())
  .then(html => {
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const newMiniCart = doc.querySelector('mini-cart');
    const currentMiniCart = document.querySelector('mini-cart');

    if (newMiniCart && currentMiniCart) {
      currentMiniCart.innerHTML = newMiniCart.innerHTML;
    }
  })
  .catch(err => console.error('Variant swap error:', err));
});

//-------------

function updateVisitors() {
  const visitorEl = document.getElementById("visitor-count");
  
  if (!visitorEl) return;

  var min = 5;
  var max = 25;
 
  var randomVisitors = Math.floor(Math.random() * (max - min + 1)) + min;
 
  visitorEl.innerText = randomVisitors;
}


document.addEventListener('DOMContentLoaded', function() {

  updateVisitors();
  
  setInterval(updateVisitors, 15000);

  const closeBtn = document.querySelector('#live-visitors .close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function(){
      const liveVisitors = document.getElementById('live-visitors');
      if (liveVisitors) {
        liveVisitors.style.display = 'none';
      }
    });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.js-size-guide-btn');
    if (!btn) return;

    const content = btn.dataset.sizeGuide;
    const container = document.querySelector('#MiniCartSizeGuideContent');

    if (container && content) {
      container.innerHTML = content;
    }
  });
});



 function initCustomCardSwipe() {

  document.querySelectorAll('.product-card-wrapper').forEach((card) => {

    if (card.classList.contains('swipe-ready')) return;
    card.classList.add('swipe-ready');

    const slideshow = card.querySelector('.product-image-slideshow');
    const dots = card.querySelectorAll('.dot');

    if (!slideshow) return;

    const slides = slideshow.querySelectorAll('img');

    // =========================
    // IMAGE SLIDER CSS
    // =========================
    slideshow.style.display = 'flex';
    slideshow.style.overflowX = 'auto';
    slideshow.style.scrollSnapType = 'x mandatory';
    slideshow.style.scrollBehavior = 'smooth';
    slideshow.style.webkitOverflowScrolling = 'touch';

    slides.forEach((slide) => {
      slide.style.minWidth = '100%';
      slide.style.flexShrink = '0';
      slide.style.scrollSnapAlign = 'start';
    });

    // =========================
    // DOTS ACTIVE
    // =========================
    function updateDots() {

      const index = Math.round(
        slideshow.scrollLeft / slideshow.clientWidth
      );

      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
      });
    }

    slideshow.addEventListener('scroll', updateDots);

    dots.forEach((dot, i) => {

      dot.addEventListener('click', () => {

        slideshow.scrollTo({
          left: slideshow.clientWidth * i,
          behavior: 'smooth'
        });

      });

    });

    // =====================================================
    // IMAGE SECTION SWIPE ONLY IMAGE
    // =====================================================

    let startX = 0;

    slideshow.addEventListener('touchstart', (e) => {

      startX = e.touches[0].clientX;

    }, { passive: true });

    slideshow.addEventListener('touchmove', (e) => {

      const moveX = e.touches[0].clientX;
      const diff = Math.abs(startX - moveX);

      // prevent parent slick
      if (diff > 10) {
        e.stopPropagation();
      }

    }, { passive: true });


    // =====================================================
    // TEXT AREA SWIPE = PARENT SLICK
    // =====================================================

    const nonImageArea = card.querySelector('.card__information');

    if (!nonImageArea) return;

    let textStart = 0;

    nonImageArea.addEventListener('touchstart', (e) => {

      textStart = e.touches[0].clientX;

    }, { passive: true });

    nonImageArea.addEventListener('touchend', (e) => {

      const endX = e.changedTouches[0].clientX;

      const diff = textStart - endX;

      // parent slick slider
      const slickSlider = jQuery(card).closest('.slick-slider');

      if (!slickSlider.length) return;

      if (Math.abs(diff) < 40) return;

      if (diff > 0) {

        slickSlider.slick('slickNext');

      } else {

        slickSlider.slick('slickPrev');

      }

    }, { passive: true });

  });

}


// INIT
document.addEventListener('DOMContentLoaded', initCustomCardSwipe);


// SHOPIFY DYNAMIC LOAD
new MutationObserver(() => {

  initCustomCardSwipe();

}).observe(document.body, {
  childList: true,
  subtree: true
});
